export default __webpack_public_path__ + "static/media/logo-white.0e0f635b.svg";